import { Link } from "@fhs/link";
import { Button, type ButtonProps } from "@fhs/ui";

export type SignUpButtonProps = Omit<ButtonProps, "children">;

export function SignUpButton(props: SignUpButtonProps) {
  return (
    <Link href="/signup">
      <Button type="outline" aria-label="Open sign up" size="xs" {...props}>
        <Button.Text>Sign Up</Button.Text>
      </Button>
    </Link>
  );
}
